import { BaseEntityMapper } from '@processpuzzle/base-entity';
import { ApplicationProperty } from '@processpuzzle/base-widget';

interface ApplicationPropertyDto {
  id?: string;
  name?: string;
  value?: string;
}

/**
 * `name` and `value`, not `propertyName` and `propertyValue`. Core's entity backs both with private fields of the
 * longer names behind getters of the shorter ones, so a bare `JSON.stringify` of an entity would send the wrong
 * keys; this mapper reads and writes the contract's.
 */
export class CustomApplicationPropertyMapper implements BaseEntityMapper<ApplicationProperty> {
  fromDto(dto: unknown): ApplicationProperty {
    const property = (dto ?? {}) as ApplicationPropertyDto;
    return new ApplicationProperty(property.id, property.name, property.value);
  }

  toDto(entity: ApplicationProperty): ApplicationPropertyDto {
    return { id: entity.id, name: entity.name, value: entity.value };
  }
}
